'use strict';

angular.module('AcaApp').factory('RFMService',
[
  'RFMResource',
  function(RFMResource){
    return{
      getFilesListRFM: function(){
        var rpcConfig = {method: 'getFiles', params: []};
        return RFMResource.executeRpc(rpcConfig).$promise;
      },
      deleteFile: function(fileName){
        var rpcConfig = {method: 'deleteFile', params: [fileName]};
        return RFMResource.executeRpc(rpcConfig).$promise;
      },
      getFilesToImport: function(){
        var rpcConfig = {method: 'getFilesToImport', params: []};
        return RFMResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);
